require('./Search.scss');

const b = require('app/www/libs/b')('search-controller');
const bContent = require('app/www/libs/b')('content');

const React = require('react');
const PropTypes = require('prop-types');
const {connect} = require('react-redux');
const {withI18n} = require('app/www/components/contexts/I18n');

const {DESKTOP, TABLET, PHONE} = require('app/www/constants/devices');
const Metrika = require('app/www/libs/client/metrika');
const {search} = require('app/www/actions/search');
const {updateExternal: updateWannaSee} = require('app/www/actions/wannaSee');
const {update: updateReminders} = require('app/www/actions/reminders');
const {updateFavoriteChannels} = require('app/www/actions/favoriteChannels');

const AdvManager = require('app/www/components/blocks/AdvManager/AdvManager');
const ChannelSnippet = require('app/www/components/blocks/ChannelSnippet/ChannelSnippet');
const Content = require('app/www/components/blocks/Content/Content');
const Global = require('app/www/components/blocks/Global/Global');
const Placeholder_ProgramSnippet = require('app/www/components/blocks/Placeholder/_ProgramSnippet/Placeholder_ProgramSnippet');
const Placeholder_ChannelSnippet = require('app/www/components/blocks/Placeholder/_ChannelSnippet/Placeholder_ChannelSnippet');
const ProgramSnippet = require('app/www/components/blocks/ProgramSnippet/ProgramSnippet');
const ResizeListener = require('app/www/components/blocks/ResizeListener/ResizeListener');
const SearchResults = require('app/www/components/blocks/SearchResults/SearchResults');
const Tabs = require('app/www/components/blocks/Tabs/Tabs');
const Ua = require('app/www/components/blocks/Ua/Ua');

const TABS_IDS = {
    ALL: 'all',
    CHANNELS: 'channels',
    EVENTS: 'events',
};

const DISPLAY_CHANNELS_LIMIT = 4;
const DISPLAY_EVENTS_LIMIT = 8;

class SearchController extends React.PureComponent {
    constructor(props) {
        super(props);

        const {totalEvents, totalChannels} = props;

        this.state = {
            tabId: TABS_IDS.ALL,
            isLoading: false,
            moreChannelsCount: Math.max(totalChannels, DISPLAY_CHANNELS_LIMIT) - DISPLAY_CHANNELS_LIMIT,
            moreEventsCount: Math.max(totalEvents, DISPLAY_EVENTS_LIMIT) - DISPLAY_EVENTS_LIMIT,
        };

        this._onChangeTab = this._onChangeTab.bind(this);
        this._updateLayouts = this._updateLayouts.bind(this);
        this._onProgramClick = this._onProgramClick.bind(this);
        this._onMoreLinkClick = this._onMoreLinkClick.bind(this);
        this._getSearchResults = this._getSearchResults.bind(this);
        this._renderChannel = this._renderChannel.bind(this);
        this._renderProgram = this._renderProgram.bind(this);
        this._sendMetrika = this._sendMetrika.bind(this);
    }

    componentDidMount() {
        this._updateLayouts();
        this._sendMetrika({
            trigger: 'show',
        });
    }

    render() {
        const {
            advKey,
            tabId,
            isLoading,
            moreChannelsCount,
            moreEventsCount,
        } = this.state;

        let {
            i18n,
            text,
        } = this.props;
        const {events, channels, totalEvents, totalChannels} = this.props;

        text = text ? decodeURIComponent(text) : '';
        const title = text
            ? i18n.get('search-controller.header-title-no-results')
            : i18n.get('search-controller.header-title-empty-results');

        if (!totalChannels && !totalEvents) {
            return (
                <Content className={`${b()} ${bContent.mod({search: true})} ${bContent.mod({center: true})}`}>
                    <div className={bContent('header')}>
                        <h1 className={b('title')}>
                            {title}
                        </h1>
                    </div>
                    <div className={bContent('columns', {single: true})}>
                        <div className={bContent('main')}>
                            <div className={b('no-results-description')}>
                                {text && i18n.get('search-controller.no-results-description', {text})}
                            </div>
                        </div>
                    </div>
                </Content>
            );
        }

        const tabsProps = {
            items: [{
                id: TABS_IDS.ALL,
                text: i18n.get(`search-controller.tab-${TABS_IDS.ALL}`),
                count: totalChannels + totalEvents,
            }, {
                id: TABS_IDS.CHANNELS,
                text: i18n.get(`search-controller.tab-${TABS_IDS.CHANNELS}`),
                count: totalChannels,
                isDisabled: totalChannels === 0,
            }, {
                id: TABS_IDS.EVENTS,
                text: i18n.get(`search-controller.tab-${TABS_IDS.EVENTS}`),
                count: totalEvents,
                isDisabled: totalEvents === 0,
            }],
            selectedId: tabId,
            onChange: this._onChangeTab,
        };

        const advManagerProps = {
            blockId: Global.adv[`search_${advKey}`],
        };

        const resizeListenerProps = {
            callback: this._updateLayouts,
        };

        const channelsSearchResultProps = {
            isLoading,
            title: i18n.get('search-controller.channels-title'),
            ItemComponent: this._renderChannel,
            ItemPlaceholderComponent: Placeholder_ChannelSnippet,
            items: channels,
            total: totalChannels,
            displayLimit: DISPLAY_CHANNELS_LIMIT,
            moreLinkText: tabId === TABS_IDS.ALL ? i18n.get('search-controller.more-channels', moreChannelsCount, {number: moreChannelsCount}) : null,
            onMoreLinkClick: this._onMoreLinkClick(TABS_IDS.CHANNELS),
            loadOnScroll: tabId === TABS_IDS.CHANNELS || totalEvents === 0,
            getSearchResults: this._getSearchResults(TABS_IDS.CHANNELS),
        };

        const eventsSearchResultProps = {
            isLoading,
            title: i18n.get('search-controller.events-title'),
            ItemComponent: this._renderProgram,
            ItemPlaceholderComponent: Placeholder_ProgramSnippet,
            items: events,
            displayLimit: DISPLAY_EVENTS_LIMIT,
            total: totalEvents,
            moreLinkText: tabId === TABS_IDS.ALL ? i18n.get('search-controller.more-events', moreEventsCount, {number: moreEventsCount}) : null,
            onMoreLinkClick: this._onMoreLinkClick(TABS_IDS.EVENTS),
            loadOnScroll: tabId === TABS_IDS.EVENTS || totalChannels === 0,
            getSearchResults: this._getSearchResults(TABS_IDS.EVENTS),
        };

        return (
            <Content className={`${b()} ${bContent.mod({search: true})}`}>
                <div className={bContent('header')}>
                    <h1 className={b('title')}>
                        {i18n.get('search-controller.header-title', {text})}
                    </h1>
                </div>
                <div className={bContent('columns')}>
                    <div className={bContent('main')}>
                        <div className={b('tabs')}>
                            <Tabs {...tabsProps} />
                        </div>
                        {totalChannels > 0 && [TABS_IDS.ALL, TABS_IDS.CHANNELS].includes(tabId) && (
                            <SearchResults {...channelsSearchResultProps} />
                        )}
                        {totalEvents > 0 && [TABS_IDS.ALL, TABS_IDS.EVENTS].includes(tabId) && (
                            <SearchResults {...eventsSearchResultProps} />
                        )}
                        {[TABLET, PHONE].includes(advKey) && (
                            <div className={bContent('adv-bottom')}>
                                <AdvManager {...advManagerProps} />
                            </div>
                        )}
                    </div>
                    <div className={bContent('adv-aside')}>
                        {advKey === DESKTOP && (
                            <AdvManager sticky={true} {...advManagerProps} />
                        )}
                    </div>
                </div>
                <ResizeListener {...resizeListenerProps} />
            </Content>
        );
    }

    /**
     * @private
     * @param {Object} props
     */
    _renderChannel(props) {
        const additionalProps = {
            mods: {
                search: true,
            },
            logoMods: {
                size: 'l',
            },
            onClick: this._sendMetrika,
            section: 'channel',
            showIndicator: true,
            showButtons: true,
            firstEvent: props.currentEvent,
            metrikaParams: {
                tabId: this.state.tabId,
                channelId: props.id,
            },
        };

        return (
            <ChannelSnippet {...props} {...additionalProps} />
        );
    }

    /**
     * @private
     * @param {Object} event
     */
    _renderProgram(event) {
        const programSnippetProps = {
            event,
            onClick: this._onProgramClick,
            isTouchButtons: this.state.isTouchButtons,
            section: 'events',
            tabId: this.state.tabId,
        };

        return (
            <ProgramSnippet key={event.program.id} {...programSnippetProps} />
        );
    }

    /**
     * Переключаем таб
     * @param {String} tabId
     * @private
     */
    _onChangeTab(tabId) {
        this.setState({tabId});
        Metrika.trackParams('SEARCH_PAGE', {tabId});
    }

    /**
     * @private
     */
    _updateLayouts() {
        this.setState({
            isLayoutSmall: Ua.isLayoutColumnsSmall,
            isTouchButtons: Ua.isTouchButtons,
            advKey: Ua.isLayoutColumnsSmall ? PHONE :
                    Ua.isLayoutColumnsLarge ? TABLET : DESKTOP,
        });
    }

    /**
     * @private
     */
    _onMoreLinkClick(tabId) {
        return () => this.setState({tabId});
    }

    /**
     * Подгружает данные
     * @param {String} type
     */
    _getSearchResults(type) {
        return (page) => {
            const {text, dispatchSearch} = this.props;

            this.setState({isLoading: true});

            dispatchSearch({
                regionId: Global.regionId,
                text: decodeURIComponent(text),
                page,
                type,
            }).then(data => {
                this.setState({isLoading: false});

                this.props.dispatchUpdateWannaSee(data.wannaSee);
                this.props.dispatchUpdateReminders(data.reminders);
                this.props.dispatchUpdateFavoriteChannels(data.favoriteChannelIds);
            });
        };
    }

    /**
     * @private
     * @param {Object} searchParams
     */
    _onProgramClick(searchParams) {
        searchParams.trigger = 'click';

        return () => {
            this._sendMetrika(searchParams);
            Metrika.trackParams('TV_EVENT', {
                programId: searchParams.id,
                tabId: this.state.tabId,
            });
        };
    }

    /**
     * Отправляем данные в метрику
     * @param {Object} metrikaParams
     * @private
     */
    _sendMetrika(metrikaParams) {
        const {text} = this.props;
        const {
            id,
            index,
            title,
            section,
            trigger,
            familyId,
        } = metrikaParams;

        const decodedText = text ? decodeURIComponent(text) : '';

        Metrika.trackParams('PROJECT_SEARCH', {
            title,
            index,
            trigger,
            section,
            text: decodedText,
            limit: DISPLAY_CHANNELS_LIMIT,
            id: id && id.toString(),
            family_Id: familyId || 'no_familyId',
            tabId: this.state.tabId,
        });
    }
}

SearchController.propTypes = {
    events: PropTypes.array,
    channels: PropTypes.array,
    totalEvents: PropTypes.number,
    totalChannels: PropTypes.number,
};

function mapStateToProps(state) {
    return state.search;
}

function mapDispatchToProps(dispatch) {
    return {
        dispatchSearch: params => dispatch(search(params)),
        dispatchUpdateWannaSee: programIds => dispatch(updateWannaSee(programIds)),
        dispatchUpdateReminders: eventIds => dispatch(updateReminders(eventIds)),
        dispatchUpdateFavoriteChannels: channelIds => dispatch(updateFavoriteChannels(channelIds)),
    };
}

module.exports = connect(
    mapStateToProps,
    mapDispatchToProps
)(
    withI18n(SearchController)
);
